var _module_exports = "<div class=\"fancy-menu-details-title\">Floor</div>\n<p>\n  Rounds datapoint values down, toward zero, to the nearest integer.\n</p>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/FLOOR/description.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;